export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
// Derive a base for static atlas files from the API base (strip trailing /api if present)
export const ATLAS_BASE_URL = (() => {
  try {
    const base = API_BASE_URL || '';
    return base.replace(/\/?api\/?$/, '');
  } catch { return ''; }
})();